import { helpers } from '@vuelidate/validators';

export const samlAssertionAttributeName = helpers.regex(/^[a-zA-Z_][\w:.-]*$/);
